import React from 'react';
import useDragList from './useDragList';
import { clamp } from './math';

export default function WorksTable({ works, meta, onChange, onDel }) {
  const change = (i, k, v) => {
    const next = works.slice();
    next[i] = { ...next[i], [k]: (k === 'name' || k === 'unit' || k === 'desc') ? v : clamp(v) };
    onChange(next);
  };
  const reorder = (next) => onChange(next);
  const { onDragStart, onDragOver, onDrop, onDragEnd } = useDragList(works, reorder);

  return (
    <table className="zebra rt" id="tblWorks">
      <thead>
        <tr>
          <th style={{ width: 34 }}>№</th>
          <th>Работа</th>
          <th>Описание</th>
          <th style={{ width: 90 }}>Ед.</th>
          <th style={{ width: 160 }}>Кол-во</th>
          <th style={{ width: 120 }}>Цена, ₽/ед</th>
          <th style={{ width: 140 }}>Сумма, ₽</th>
          <th style={{ width: 44 }} className="center">✖</th>
        </tr>
      </thead>
      <tbody>
        {(works || []).map((w, i) => {
          const qty = w._manualQty ? (w._manualQtyVal || 0) : (w.autoQty || 0);
          const base = qty * (w.price || 0);
          const sum = meta?.hideMarkup ? Math.round(base + (w._add || 0)) : Math.round(base);

          return (
            <tr key={i} draggable onDragStart={onDragStart(i)} onDragOver={onDragOver(i)} onDrop={onDrop(i)} onDragEnd={onDragEnd}>
              <td data-label="№"><div className="center"><span className="drag-handle">⋮⋮</span> {i + 1}</div></td>
              <td data-label="Работа"><input value={w.name || ''} onChange={e => change(i, 'name', e.target.value)} /></td>
              <td data-label="Описание"><textarea value={w.desc || ''} onChange={e => change(i, 'desc', e.target.value)} /></td>
              <td data-label="Ед."><input value={w.unit || ''} onChange={e => change(i, 'unit', e.target.value)} /></td>
              <td data-label="Кол-во">
                <div className="muted small">
                  <label>
                    <input
                      type="checkbox"
                      checked={!!w._manualQty}
                      onChange={(e) => {
                        const next = works.slice();
                        next[i] = { ...next[i], _manualQty: e.target.checked };
                        onChange(next);
                      }}
                    />{' '}
                    ручн.
                  </label>
                </div>
                <input
                  disabled={!w._manualQty}
                  value={w._manualQtyVal ?? ''}
                  onChange={(e) => {
                    const next = works.slice();
                    next[i] = { ...next[i], _manualQtyVal: clamp(e.target.value) };
                    onChange(next);
                  }}
                />
                <div className="right small">= {Number.isFinite(qty) ? qty : 0}</div>
              </td>
              <td data-label="Цена, ₽/ед"><input value={w.price || 0} onChange={e => change(i, 'price', e.target.value)} /></td>
              <td data-label="Сумма, ₽" className="right">{sum.toLocaleString('ru-RU')}</td>
              <td data-label="Удалить" className="center"><button className="iconbtn" onClick={() => onDel(i)}>✕</button></td>
            </tr>
          );
        })}
      </tbody>
      <tfoot>
        <tr>
          <td colSpan={7} className="right">Итого работы:</td>
          <td id="workTotal" className="right">
            {Number((works || []).reduce((a, w) =>
              a + Math.round(
                ((w._manualQty ? (w._manualQtyVal || 0) : (w.autoQty || 0)) * (w.price || 0))
                + (meta?.hideMarkup ? (w._add || 0) : 0)
              ), 0)
            ).toLocaleString('ru-RU')}
          </td>
        </tr>
      </tfoot>
    </table>
  );
}
